export const ORGANIZATION_LEGAL_STRUCTURE = {
    C: {
        en: 'Corporation',
        es: 'Corporación'
    },
    L: {
        en: 'LLC',
        es: 'LLC'
    },
    P: {
        en: 'Partnership',
        es: 'Sociedad comercial'
    },
    S: {
        en: 'Sole Proprietor',
        es: 'Propietario único'
    },
    U: {
        en: 'Unknown',
        es: 'Desconocido'
    },
    O: {
        en: 'Other',
        es: 'Otro'
    }
} as Record<string, { en: string; es: string }>;
